  <header class="container-grid wrap-title-episode">
    <header class="container-grid title-size" [innerHTML]="mainPageData[0].acf.mainheader">
    </header>
  </header>
  <div class="container-grid con-video-bgr " [ngClass]="getClass(mainPageData[0].slug)" *ngIf="showVideobox">
    <div class="container-grid con-video-size">
      <div class="responsive-video vimeo con-video-inner"  >
              <iframe  [src]="videoUrl" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
    </div>
  </div>
  <section class="container-grid wrap-nav-video" *ngIf="showVideobox">

    <main class="container-grid nav-video">
      <a class="link-button btn btn-left-1004" (click)="gotoLectureBefore(mainPageData[0].acf.smallnavbefore)" title="{{btnEpisodeBefore}}"></a>
      <a class="link-button btn btn-episodes"  routerLink="." fragment="all-episodes" >
        <span class="button-link-text-2">
          <span class="button-link-text-2" id="button-link-text-1">
            <font color="#ffffff" class="button-link-text-1">{{btnallEpisodes}}</font>
          </span>
        </span>
      </a>
      <a class="link-button btn btn-right-1004"  (click)="gotoLectureNext(mainPageData[0].acf.smallnavnext)" title="{{btnEpisodeNext}}"></a>
    </main>
  </section>

  <article class="container-grid wrap-main-text-episodes">
    <div class="container-grid wrap-quote" [ngClass]="getlection1Class(mainPageData[0].slug)" [innerHTML]="mainPageData[0].acf.quoteblock">
      <div class="lds-dual-ring"></div>
    </div>

    <main class="container-grid container-main-text-episodes">
      <main class="container-grid main-text-episodes" [innerHTML]="mainPageData[0].acf.maincontent">
        <div class="lds-dual-ring"></div>
      </main>
      <div class="rule rule-2" *ngIf="showWorksheetHR">
        <hr>
      </div>
      <div class="container-grid wrap-worksheet one" [innerHTML]="mainPageData[0].acf.worksheetblock" >

          <div class="lds-dual-ring"></div>

      </div>
      <div class="container-grid wrap-worksheet all">
        <a href="{{allWorksheetsFile}}" class="link-container link-container-worksheet all">
          <div class="responsive-picture picture-worksheet">
            <picture><img alt="Placeholder Picture" src="./assets/Download-NY.png"></picture>
          </div>
          <p class="paragraph text-worksheet">{{allWorksheets}}<br></p>
        </a>
      </div>
      <div class="rule rule-1" *ngIf="showExtraMaterialHR">
        <hr>
      </div>
      <div class="container-grid external-links" [innerHTML]="mainPageData[0].acf.extramaterialblock">
        <div class="lds-dual-ring"></div>
      </div>
      <div class="container-grid div-headings ep1" *ngIf="showExtraVideobox">
        <h1 class="title-episode">{{btnParticipants}}<br></h1>
      </div>
      <section class="container-grid wrap-video-ep1" *ngIf="showExtraVideobox">
        <div class="responsive-video vimeo">
          <iframe [src]="extravideoUrl" frameborder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
      </section>
    </main>
  </article>
<app-coursenav></app-coursenav>
